<template>
    <label class="switch">
      <input type="checkbox" v-model="isChecked" @change="handleChange">
      <span class="slider round"></span>
    </label>
  </template>
  
  <script>
  export default {
    data() {
      return {
        isChecked: false
      };
    },
    methods: {
      handleChange() {
        this.$emit('change', this.isChecked);
      }
    },
    mounted() {
        this.handleChange();
    },
  };
  </script>
  
  <style scoped>
  /* 开关的样式 */
  .switch {
    position: relative;
    display: inline-block;
    width: 32px;
    height: 16px;
  }
  
  /* 隐藏默认的checkbox */
  .switch input {
    opacity: 0;
    width: 0;
    height: 0;
  }
  
  /* 滑块的样式 */
  .slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    transition: 0.1s;
    border-radius: 34px;
  }
  
  .slider:before {
    position: absolute;
    content: "";
    height: 16px;
    width: 16px;
    left: 1px;
    bottom: 0px;
    background-color: white;
    transition: 0.1s;
    border-radius: 50%;
  }
  
  /* 当checkbox被选中时，改变滑块的背景色 */
  input:checked + .slider {
    background-color: #2196F3;
  }
  
  /* 当checkbox被选中时，移动滑块 */
  input:checked + .slider:before {
    transform: translateX(16px);
  }
  
  /* 圆角样式 */
  .round {
    border-radius: 34px;
  }
  
  .round:before {
    border-radius: 50%;
  }
  </style>